import { cn } from "@onclicks/sharedcomponents/ui";
import { Anchor } from "@/payload-types";
import { CMSLinkType } from "@/types/CMSLink";
import { Link } from "@onclicks/sharedmobilei18n/routing";
import { useLocale } from "next-intl";
import React from "react";
import { Button, type ButtonProps } from "./ui/Button";
import { Icon } from "./Icon";

export const CMSLink: React.FC<
  CMSLinkType<ButtonProps["variant"], ButtonProps["size"]>
> = (props) => {
  const {
    type,
    appearance = "inline",
    children,
    className,
    label,
    newTab,
    reference,
    size: sizeFromProps,
    reactIconsIcon,
    url,
  } = props;

  const locale = useLocale();

  let href: string | undefined | null = url;

  href = getHref();

  if (!href) return null;

  const isAnchor = href.startsWith("#") || href.startsWith("/#");

  if (isAnchor) {
    // On force le préfixe de langue courante pour que l'URL générée
    // corresponde exactement à la page affichée : sans ça (ex. "/#ancre"),
    // le localePrefix "always" redirige "/" vers "/fr" et on perd le scroll
    // vers l'ancre au passage (rechargement complet de la page).
    href = `/${locale}#${href.replace(/^\/?#/, "")}`;
  }
  const size = appearance === "link" ? "clear" : sizeFromProps;
  const newTabProps = newTab
    ? { rel: "noopener noreferrer", target: "_blank" }
    : {};

  // Button autour de a et Link = lien ressemble à un bouton graphique, propriété asChild transmet toutes ses propriétés CSS à ses enfants
  // apparence inline = apparence simple, texte standard
  if (isAnchor) {
    if (appearance === "inline") {
      return (
        <a href={href} className={cn(className)}>
          <Icon reactIconsIcon={reactIconsIcon} className="" />
          {label}
          {children}
        </a>
      );
    } else {
      return (
        <Button asChild className={className} size={size} variant={appearance}>
          <a href={href} className={cn(className)}>
            <Icon reactIconsIcon={reactIconsIcon} className="" />
            {label}
            {children}
          </a>
        </Button>
      );
    }
  } else {
    if (appearance === "inline") {
      return (
        <Link className={cn(className)} href={href} {...newTabProps}>
          <Icon reactIconsIcon={reactIconsIcon} className="" />
          {label && label}
          {children && children}
        </Link>
      );
    } else {
      return (
        <Button asChild className={className} size={size} variant={appearance}>
          <Link className={cn(className)} href={href} {...newTabProps}>
            <Icon reactIconsIcon={reactIconsIcon} className="" />
            {label && label}
            {children && children}
          </Link>
        </Button>
      );
    }
  }

  function getHref() {
    if (
      type === "reference" &&
      reference?.value &&
      typeof reference.value === "object"
    ) {
      if (reference.relationTo === "anchors") {
        // Pour Anchors
        const anchorVal = (reference.value as Anchor).anchor;
        return `/#${anchorVal.replace(/^#/, "")}`;
      } else if (
        "slug" in reference.value &&
        reference.value.slug !== null &&
        reference.value.slug !== undefined
      ) {
        // Pour Pages / Posts
        return `${reference.relationTo !== "pages" ? `/${reference.relationTo}` : ""}/${reference.value.slug}`;
      }
    }

    if (type === "custom" && url) {
      return url;
    }
    return null;
  }
};
